import { AxiosResponse } from "axios";
import Diversity from "../../models/common/diversity.model";
import ExperienceTime from "../../models/common/experience-time.model";
import HireType from "../../models/common/hire-type.model";
import ProfessionalMoment from "../../models/common/professional-moment.model";
import Proficiency from "../../models/common/proficiency.model";
import talentApi from "./talent-api-config";
import Skill from "../../models/common/skill.model";
import City from "../../models/common/city.model";
import { SignUpReasonInterface } from "../../models/common/sign-up-reason.model";


class CommonApi {

    async fetchExperienceTime(): Promise<AxiosResponse<ExperienceTime[]>> {
        return talentApi.get<ExperienceTime[]>(`/experience-time/?candidate=true`);
    }

    async fetchDiversity(): Promise<AxiosResponse<Diversity[]>> {
        return talentApi.get<Diversity[]>(`/diversities/`);
    }

    async fetchProficiency(): Promise<AxiosResponse<Proficiency[]>> {
        return talentApi.get<Proficiency[]>(`/languages/proficiency/`);
    }

    async fetchHireType(): Promise<AxiosResponse<HireType[]>> {
        return talentApi.get<HireType[]>(`/hire-type/`);
    }

    async fetchDegree(): Promise<AxiosResponse<HireType[]>> {
        return talentApi.get<HireType[]>(`/degrees/`);
    }

    async fetchProfessionalMoment(): Promise<AxiosResponse<ProfessionalMoment[]>> {
        return talentApi.get<ProfessionalMoment[]>(`/professional-moments/`);
    }

    async fetchAllSkills(): Promise<AxiosResponse<Skill[]>> {
        return await talentApi.get<Skill[]>(`/talent/pool/skills/`);
    }

    async fetchCities(name: string): Promise<AxiosResponse<City[]>> {
        return talentApi.get<City[]>(`/cities/?name=${name}`);
    }

    async fetchCityById(id: number | string): Promise<AxiosResponse<City>> {
        return talentApi.get<City>(`/cities/${id}/`);
    }

    async fetchSignUpReasons(): Promise<AxiosResponse<SignUpReasonInterface[]>> {
        return talentApi.get<SignUpReasonInterface[]>(`/talent/signup-reasons`);
    }
}

export const commonApi = new CommonApi();
